import type { TabularSheetCellValue } from '../../shared/tabular-sheet-payload.model';

export const DWT_DEFRA_SUBMISSIONS_SHEET_COLUMNS = [
    { key: 'wasteTrackingId', header: 'Waste Tracking Id' },
    { key: 'submissionDateTime', header: 'Submission Date and Time' },
    { key: 'submissionStatus', header: 'Submission Status' },
    { key: 'yourUniqueReference', header: 'Your Unique Reference' },
    { key: 'name', header: 'Name' },
    { key: 'value', header: 'Value' },
    { key: 'fieldErrorsAndWarnings', header: 'Field Errors and Warnings' },
] as const;

export type DwtDefraSubmissionsSheetColumnKey =
    (typeof DWT_DEFRA_SUBMISSIONS_SHEET_COLUMNS)[number]['key'];

export const DWT_DEFRA_SUBMISSIONS_TABLE_HEADERS: readonly string[] =
    DWT_DEFRA_SUBMISSIONS_SHEET_COLUMNS.map((column) => column.header);

/** One Excel row: submission metadata repeated for each JSON field sent to DEFRA. */
export interface DwtDefraSubmissionSheetRow {
    readonly wasteTrackingId: string;
    readonly submissionDateTime: string;
    readonly submissionStatus: string;
    readonly yourUniqueReference: string;
    readonly name: string;
    readonly value: TabularSheetCellValue;
    readonly fieldErrorsAndWarnings: string;
}
